<template>
    <div id="OfferBasket" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true" @keyup.esc="closeModal()">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
            <div class="modal-content total bg-olf-light-greyish-blue">
                <!-- HEADER -->
                <div class="modal-header pt-5 px-4"
                     :class="  basket.isDeliveredIn ? 'flex-column' : 'flex-row' "
                >
                    <h1 class="modal-title mt-0 heading-large">{{header}}</h1>
                    <span v-if="basket.isDeliveredIn" class="modal-title mt-1 heading-small"> Diesel & Gasoil pot sizes are 6,0000 litres. Kerosene pot sizes are 6,250 litres </span>
                    <button type="button" data-dismiss="modal" class="modal-close" aria-label="Cancel" 
                        @click="closeModal()">
                        <i class="fas fa-lg fa-times"></i>
                    </button>
                </div>

                <div v-if='errorMessageBool'
                    class="w-100 alert alert-danger mt-3 text-center">
                    <i class="fas fa-info-circle mr-2"></i>{{errorMessage}}
                </div>   

                <!-- BASKET -->
                <div class="modal-body">
                    <div class="table-container bg-white shadow"
                        :class="{'pt-1 px-3' : $breakpoint.mdAndDown}"
                    >
                        <!-- Start of Normal Basket -->
                        <table v-if="!basket.isDeliveredIn" class="table responsive-table">
                            <thead>
                                <tr>
                                    <th v-if="basket.isBunkering && !basket.isContract"> Account No. </th>
                                    <th v-if="basket.isContract"> Contract Ref </th>
                                    <th> Product </th>  
                                    <th v-if="!basket.isBunkering"> Terminal </th> 
                                    <th v-else> Network </th>  
                                    <th> Seller  </th> 
                                    <th class="text-center"> Volume/L </th>
                                    <th> Measure </th>
                                    <th v-if="!basket.isBunkering"> Lifting Period </th>
                                    <th> Payment Terms </th>
                                    <th> Price (ppl)</th>
                                    <th style="max-width:100px; min-width:100px;"> Total £</th>
                                    <th> </th>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-for="(offer,key) in basket.offers" > 
                                    <tr :class="{'w-100 pt-2 pb-5' : $breakpoint.mdAndDown}" :key="key">
                                        <td label="Account No." v-if="basket.isBunkering && !basket.isContract">   
                                            <input class="form-control white-field bg-olf-light-greyish-blue" v-model="offer.reference" placeholder="Enter Account..."  @keypress="isNumberKeyEvent($event)"/>
                                            <span v-if="bunkeringAccountInputError(offer)" class="error-message">Please enter an account number</span>
                                        </td>
                                        <td label="Contract Ref" v-if="basket.isContract"> {{ offer.contract.reference }} </td>
                                        <td label="Product"> {{offer.fuel_id | fueltype}} </td>
                                        <td label="Terminal" v-if="!basket.isBunkering"> {{offer.terminal.name}} </td>
                                        <td label="Network" v-else> {{getFullNetworkName(offer.networkId)}} </td>
                                        <td label="Seller"> {{offer.seller.name}} </td>
                                        <td label="Volume/L"> 
                                            <cleave  
                                                class="form-control white-field bg-olf-light-greyish-blue text-center" 
                                                @keypress="isNumberKeyEvent($event)" v-model="offer.quantity" 
                                                :options="numeralPositive" 
                                                :placeholder="maxMinPlaceholderValues(offer)"
                                                maxlength="10"
                                            ></cleave>
                                            <span v-if='offerQuantityValidError(offer)' class="error-message">{{offerQuantityValidError(offer)}}</span>
                                        </td>
                                        <td label="Measure"> {{offer.fuel_measurement_id | fuelmeasurementtype}} </td>
                                        <td label="Lifting Period" v-if="!basket.isBunkering "> {{offer | liftingperiodformat}} </td>
                                        <td label="Payment Terms"> {{offer.credit.days | creditdaysformat}} </td>
                                        <td label="Price (ppl)"> {{offer.price | priceformat}} </td>  
                                        <td style="max-width:100px; min-width:100px;" label="Total £"> {{offer.quantity * offer.price/100 | priceformat}} </td>
                                        <td class="td-actions">
                                            <button 
                                                class="btn btn-icon td-sticky td-right-bottom"
                                                :class="{'pt-3' : $breakpoint.mdAndDown}"
                                                @click="removeOfferFromBasket(offer)">
                                                <i class="fas fa-trash-alt fa-lg" ></i>
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>

                            <!--Normal FOOTER -->
                            <tfoot>
                                <tr>
                                    <td class="px-3" colspan="11">
                                        <div class="totals float-right text-tertiary my-2 ">
                                            <div class="d-flex justify-content-between my-3">
                                                <div class="w-50 text-right">
                                                    <label> Total Cost ex VAT: </label>                       
                                                </div>
                                                <div class="w-50 font-weight-bold text-right">
                                                    £ {{ totalCost | priceformat }}                
                                                </div>
                                            </div>

                                            <credit-line-selection v-if="showCreditLineSelection" :brandProp="basket.brand" :brands="brands" :creditLineRequiredBool="creditLineRequiredBool" @emitBrand="updateBrandValue"/>
                                            <contract-credit v-if="contractBrand" :contractBrand="contractBrand"/>

                                            <div v-if="!basket.isContract" class="d-flex justify-content-between my-3">
                                                <label class="align-self-center w-50 text-right"> Order Reference (Optional)</label>
                                                <input v-model="basket.reference" class="form-control w-25 white-field bg-olf-light-greyish-blue"/>
                                            </div>
                                            
                                            <div class="tickbox d-flex align-items-center py-2" >
                                                <div>
                                                    <span class="pr-2" :class="{'error-message': showTickboxError}">
                                                        Please tick to confirm all the information in this order is correct.<br> Deal is subject to credit and compliance approval from this supplier.
                                                    </span>
                                                </div>
                                                <div>
                                                    <input class="float-right ml-2 mr-0" :style="showTickboxError ? 'border-color:red': ''" type="checkbox" v-model="confirmCheckbox"/>
                                                </div>
                                            </div>  
                                            <div class="d-flex justify-content-between align-items-center pt-0"
                                                :class="{'flex-column' : $breakpoint.mdAndDown}"
                                                >
                                                <div class="basket-countdown my-3">
                                                    <radial-progress-bar class="countdown-progress prices-lock" 
                                                        :diameter="$breakpoint.smAndDown ? 55 : 50" 
                                                        :totalSteps="BASKET_TIME_LIMIT" 
                                                        :completedSteps="mixin_time" 
                                                        :class="[{ 'green': mixin_time >= 60 },
                                                                {  'amber': mixin_time >= 30 && mixin_time < 60 },
                                                                {  'red' : mixin_time < 30 },]
                                                    "/>
                                                    <i class="fas fa-lock" 
                                                        :class="[{ 'green': mixin_time >= 60 },
                                                                {  'amber': mixin_time >= 30 && mixin_time < 60 },
                                                                {  'red' : mixin_time < 30 }]"></i>
                                                    <span  :class="{'mx-2' : $breakpoint.mdAndDown}" 
                                                            class="countdown-message">These prices are locked for the next<br/>{{ mixin_time | countdownfullformat }}
                                                    </span>
                                                </div>  

                                                <div>
                                                    <button v-if='closeBasketBool'
                                                        :class="{'my-2' : $breakpoint.mdAndDown}" 
                                                        class="btn btn-danger w-120px"
                                                        @click="closeModal()">
                                                        Close Basket
                                                    </button>
                                                    <button v-else-if="mixin_time < 1"
                                                        :class="{'my-2' : $breakpoint.mdAndDown}"  
                                                        class="btn btn-primary w-120px"
                                                        @click="refreshBasket()">
                                                        Refresh Offers
                                                    </button>
                                                    <button v-else
                                                        class="w-120px"
                                                        :class="{
                                                          'my-2' : $breakpoint.mdAndDown,
                                                          'btn btn-tertiary': !confirmCheckbox || requirementsNotSatisfied,
                                                          'btn btn-primary': confirmCheckbox && !requirementsNotSatisfied
                                                          }"
                                                        @click="buyOffer($event)"
                                                        :disabled="!confirmCheckbox || requirementsNotSatisfied">
                                                        Confirm
                                                    </button>
                                                </div>  
                                            </div>
                                        </div>
                                        <div :class="[$breakpoint.lgAndDown ? 'w-100' : 'w-50']" class="float-left text-tertiary align-items-center py-3">
                                            <div class="d-flex-column">
                                                <div class="py-1"> Order Notes </div>
                                                <textarea class="w-100" rows="10" columns='10' v-model="basket.orderNotes"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot> 
                        </table>
                        
                        <!-- Start of Delivered In Basket -->
                        <table v-else-if='basket.isDeliveredIn' class="table responsive-table">
                            <thead>
                                <tr>
                                    <th> Delivery Location </th>
                                    <th> Delivery Date </th>
                                    <th> Supplier  </th>
                                    <th> Payment Terms </th>
                                    <th> Product </th>
                                    <th> Measure </th>
                                    <th class="text-center"> Volume/L </th>
                                    <th> Pots </th>
                                    <th> Price (ppl)</th>
                                    <th style="max-width:100px; min-width:100px;"> Total £</th>
                                    <th> </th>
                                </tr>  
                            </thead>
                            <tbody> 
                                <template v-for="(offer,key) in basket.offers">
                                    <tr :class="{'w-100 pt-2 pb-5' : $breakpoint.mdAndDown}" :key="key">                                
                                        <td label="Delivery Location">{{basket.deliveredInData.location.name}} ({{basket.deliveredInData.location.postCode}}) </td>
                                        <td label="Delivery Date">{{basket.deliveredInData.deliveryDate | timestampformat}} </td>
                                        <td label="Supplier"> {{offer.seller.name}} </td>
                                        <td label="Payment Terms"> {{offer.credit.days | creditdaysformat}} </td>
                                        <td label="Product"> {{offer.fuel_id | fueltype}} </td>
                                        <td label="Measure"> {{offer.fuel_measurement_id | fuelmeasurementtype}} </td>
                                        <td class="align-items-center" label="Volume/L">                                       
                                            <div class="select-wrapper">
                                                <select v-model="offer.quantity" >
                                                    <option v-for="(volume, key) in dinOptions(offer)" :key="key" :value="volume">
                                                        <span v-if="volume == 0">None</span>
                                                        <span v-else>{{volume | volumeformat}}</span>
                                                    </option>
                                                </select>
                                            </div>
                                        </td>
                                        <td label="Pots"> 
                                            <div class="font-weight-bold">{{getPotsDin(offer)}}</div>
                                            <div>{{getPriceDin(offer)}}</div>
                                        </td>
                                        <td label="Price (ppl)"> {{offer.price | priceformat}} </td>  
                                        <td style="max-width:80px; min-width:80px;" label="Total £"> {{offer.quantity * offer.price/100 | priceformat}} </td>
                                        <td class="td-actions">
                                            <button 
                                                class="btn btn-icon td-sticky td-right-bottom"
                                                :class="{'pt-3' : $breakpoint.mdAndDown}"
                                                @click="removeOfferFromBasket(offer)">
                                                <i class="fas fa-trash-alt fa-lg" ></i>
                                            </button>
                                        </td>
                                    </tr>
                                </template>
                            </tbody>

                            <!--Delivered In FOOTER -->
                            <tfoot>
                                <tr>
                                    <td class="px-3" colspan="11"> 
                                        <div class="float-right text-tertiary my-3">
                                            <div class="border-bottom py-3">
                                              <div class="container">
                                                <div class="row">
                                                  <div class="progress-parent d-flex justify-content-between col-12">
                                                    <div class="d-flex" :class="{'px-2' : $breakpoint.mdAndDown}">
                                                        <span><b>{{totalVolume | volumeformat}}</b></span>
                                                        <span class=" litres text-olf-quick-silver"> /L </span>
                                                    </div>
                                                    <div class="progress w-75 align-self-center">
                                                        <div class="progress-bar" :class="{'bg-danger': showDinError}" role="progressbar" :style="dinProgressBarLoadingWidth"  aria-valuemin="0" aria-valuemax="100"></div>
                                                    </div>
                                                    <div class="d-flex" :class="{'px-2' : $breakpoint.mdAndDown}">
                                                        <span class="text-olf-quick-silver"> /Truck </span>
                                                    </div>
                                                  </div>
                                                </div>
                                                <div class="row">
                                                  <div class="col-12">
                                                    <span style="padding-left:7em" v-if='showDinError' class="error-message">Order volume must be for a full load</span>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="d-flex justify-content-between my-3">
                                                <div class="w-50 text-right">
                                                    <label> Total Cost ex VAT: </label>                       
                                                </div>
                                                <div class="w-50 font-weight-bold text-right">
                                                    £ {{ totalCost | priceformat }}                
                                                </div>
                                            </div>

                                            <credit-line-selection v-if="showCreditLineSelection" :brands="brands" :creditLineRequiredBool="creditLineRequiredBool" @emitBrand="updateBrandValue"/>
                                            <contract-credit v-if="contractBrand" :contractBrand="contractBrand"/>
                                            
                                            <div v-if="!basket.isContract" class="d-flex justify-content-between my-3">
                                                <label class="align-self-center w-50 text-right" > Order Reference (Optional)</label>
                                                <input v-model="basket.reference" class="form-control w-25 white-field bg-olf-light-greyish-blue"/>
                                            </div>
                                            
                                            <div class="tickbox d-flex align-items-center py-2">
                                                <div>
                                                    <span class="pr-2" :class="{'error-message': showTickboxError}">
                                                        Please tick to confirm all the information in this order is correct.<br> Deal is subject to credit and compliance approval from this supplier.
                                                    </span>
                                                </div>
                                                <div>                                              
                                                    <input class="float-right ml-2 mr-0" :style="showTickboxError ? 'border-color:red': ''" type="checkbox" v-model="confirmCheckbox"/>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center pt-0"
                                                :class="{'flex-column' : $breakpoint.mdAndDown}"
                                            >
                                                <div class="basket-countdown my-3">
                                                    <radial-progress-bar class="countdown-progress prices-lock" 
                                                        :diameter="$breakpoint.smAndDown ? 55 : 50"                                                        
                                                        :totalSteps="BASKET_TIME_LIMIT" 
                                                        :completedSteps="mixin_time" 
                                                        :class="[{ 'green': mixin_time >= 60 },
                                                                {  'amber': mixin_time >= 30 && mixin_time < 60 },
                                                                {  'red' : mixin_time < 30 }]"/>
                                                    <i class="fas fa-lock" 
                                                        :class="[{ 'green': mixin_time >= 60 },
                                                                {  'amber': mixin_time >= 30 && mixin_time < 60 },
                                                                {  'red' : mixin_time < 30 }]"></i>
                                                    <span  :class="{'mx-2' : $breakpoint.mdAndDown}" 
                                                            class="countdown-message">These prices are locked for the next<br/>{{ mixin_time | countdownfullformat }}
                                                    </span>
                                                </div>  

                                                <div>
                                                    <button v-if='closeBasketBool'
                                                        :class="{'my-2' : $breakpoint.mdAndDown}" 
                                                        class="btn btn-danger w-120px"
                                                        @click="closeModal()">
                                                        Close Basket
                                                    </button>
                                                    <button v-else-if="mixin_time < 1" 
                                                        :class="{'my-2' : $breakpoint.mdAndDown}" 
                                                        class="btn btn-primary w-120px"
                                                        @click="refreshBasket()">
                                                        Refresh Offers
                                                    </button>
                                                    <button v-else
                                                        :class="{
                                                          'my-2' : $breakpoint.mdAndDown,
                                                          'btn btn-tertiary': !confirmCheckbox || requirementsNotSatisfied,
                                                          'btn btn-primary': confirmCheckbox && !requirementsNotSatisfied
                                                          }"
                                                        @click="buyOffer($event)"
                                                        :disabled="!confirmCheckbox || requirementsNotSatisfied"
                                                      >
                                                        Confirm
                                                    </button>
                                                </div>  
                                            </div>
                                        </div>
                                        <div :class="[$breakpoint.lgAndDown ? 'w-100' : 'w-50']" class="float-left text-tertiary align-items-center py-3">
                                            <div class="d-flex-column">
                                                <div class="py-1"> Delivery Notes </div>
                                                <textarea class="w-100" rows="10" columns='10' v-model="basket.deliveryNotes"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <!-- Product Recommendations -->
                <h3 class="modal-header px-4 m-0">
                    <span v-if="basket.isBunkering"> Also available</span>
                    <span v-else> Also available from this terminal</span>
                </h3>
                <div v-if="myBasketRecommendations.length > 0" class='recommendations-parent'>
                    <div v-for="(recommended, key) in myBasketRecommendations" :key="key" 
                         :class="[$breakpoint.mdAndDown ? 'recommendations border-light d-inline-block w-100' : 'recommendations card border-light mb-3 d-inline-block py-3']">
                        <div class="table">
                            <table class="modal-table w-100"  :class="{'responsive-table' : $breakpoint.mdAndDown}">
                                    <th :class="{'hidden' : $breakpoint.mdAndDown}" class="pl-3">
                                        <span v-if="basket.isBunkering"> Network </span>
                                        <span v-else> Product </span>
                                    </th>
                                    <th :class="{'hidden' : $breakpoint.mdAndDown}"><span> Seller </span></th>
                                    <th :class="{'hidden' : $breakpoint.mdAndDown}"><span> Vol Min/L </span></th>
                                    <th :class="{'hidden' : $breakpoint.mdAndDown}"><span> Vol Max/L </span></th>
                                    <th :class="{'hidden' : $breakpoint.mdAndDown}"><span> Price PPL </span></th>
                                    <th :class="{'hidden' : $breakpoint.mdAndDown}"></th>
                                <tbody>
                                    <tr :class="{'d-flex flex-column' : $breakpoint.mdAndDown}">
                                        <td label="Product">
                                            <span v-if="basket.isBunkering"> {{ recommended.networkId | networksname }} </span>
                                            <span v-else> {{ recommended.fuel_id | fueltype }}  </span>
                                        </td>
                                        <td label="Seller"><span> {{ recommended.seller.name }} </span></td>
                                        <td label="Vol Min/L"><span > {{ recommended.minimumOrderQuantity | volumeformat }} </span></td>
                                        <td label="Vol Max/L"><span > {{ recommended.maximumAvailable | volumeformat }} </span></td>
                                        <td label="Price PPL"><span > {{ recommended.price | priceformat }} </span></td>
                                        <td class="justify-content-end">
                                            <button type="button" 
                                                    @click="addOfferToBasket(recommended, $event)" 
                                                    class="btn btn-primary my-2">
                                                    Add To Order
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div v-else class='recommendations-parent'>
                  <div  :class="[$breakpoint.mdAndDown ? 'recommendations border-light d-inline-block w-100' : 'recommendations card border-light mb-3 d-inline-block py-3 pl-3']">
                      <span v-if="basket.isBunkering"> No additional offers are available at the moment </span>
                      <span v-else> No additional offers are available from this terminal at the moment </span>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import TimerMixin from '@/mixins/TimerMixin';
import breakpoint from '@/mixins/index';

import { makeOfferBasketIntoDeliveredIn, createServerSideBasket, 
        updateSelectedBrandInBasket, addAllItemsToApiBasket } from '../api/basket';
import { placeOrderV2 } from '../api/orders';
import { getRecommendedOffers } from '../api/offers'

import { createBasketRecommendationsQuery} from '../util/basket';
import { priceFormat, volumeFormat } from '../util/filters';
import { isNumberKeyEvent } from '../util/util';
import { makeGenericContractFromContractFrequency } from '../util/contracts';

import CreditLineSelection from '@/components/OfferBasket/CreditLineSelection.vue'
import ContractCredit from '@/components/OfferBasket/ContractCredit.vue'

const CREDIT_LIMIT_ERROR = 'Oops! The value of this order exceeds your credit limit. Please go to My Sellers page for more information'
const OFFER_UPDATED_ERROR = 'Oops! Something in the basket has changed. Please refresh the basket'
const OFFER_REMOVED_ERROR = 'Oops! This basket is no longer available. Please close this basket to view available offers'
const MARKET_WINDOW_BASKET_ERROR = 'This basket is out of date. Please close and refresh the browser.'
const INTERNET_PROBLEMS_ERROR = 'Place Order Error message: placing order failed, please check internet and try again'


export default {
    data(){
        return {
            BASKET_TIME_LIMIT: 90,
            KERO_POT_SIZE: 6250,
            OTHER_POT_SIZE:6000,
            TOTAL_AMOUNT_OF_POTS: 6,
            confirmCheckbox: false,
            header: '',
            basket: {},
            tickboxUncheckedBool: false,
            showReferenceBool: false,
            closeBasketBool: false,
            errorMessageBool: false,
            errorMessage: 'Something went wrong, please refresh :(',
            brands: []
        }
    },
    props:['basketProp'],
    mixins:[TimerMixin, breakpoint],
    components:{
      CreditLineSelection,
      ContractCredit
    },
    created(){
        this.header = this.getHeading();
        this.brands = this.basketProp.brands

        //Using Object.assign() forces all dynamically added nested elements to be reactive
        this.basket = Object.assign({}, this.basketProp);
    },
    mounted(){
        $('#OfferBasket').modal({backdrop: 'static', keyboard: false});
        this.createBasketRecommendations(this.basketProp.offers[0]);
        this.mixin_startTimer();
    },
    watch:{
      "basket.offers": {
        deep: true,
        handler() {
          this.disableCheckBox();
        },
      },
    },
    computed: {
        ...mapGetters('offers',['basketRecommendations']),
        ...mapGetters('orders',['marketWindowId']),
        ...mapGetters('inputCheckers', ['numeralPositive']),
        ...mapGetters('metadata', ['productConfig', 'networkConfig']),
        ...mapGetters('accounts', ['getSuppliersChanges']),
        showCreditLineSelection: function(){
            return !this.basket.isContract && this.brands && this.brands.length > 0;
        },
        contractBrand: function() {
          if (this.basket.isContract && this.brands && this.brands.length > 0 && this.basket.offers[0]) {
            const offer = this.basket.offers[0];
            if (offer.meta && offer.meta.integration && offer.meta.integration.brand && offer.meta.integration.brand._id) {
              const brand = this.brands.find(brand => brand._id === offer.meta.integration.brand._id);
              return brand;
            }
          }
          return false;
        },
        showTickboxError:{
            get: function(){
                if(this.confirmCheckbox){
                    this.tickboxUncheckedBool = true
                    return !this.confirmCheckbox;
                } else if(this.tickboxUncheckedBool) {
                    return !this.confirmCheckbox;
                }
                return false
            }
        },
        showDinError:{
          get: function(){
            return this.tickboxUncheckedBool && this.totalPotsUsed < this.TOTAL_AMOUNT_OF_POTS;
          }
        },
        dinProgressBarLoadingWidth:{
            get: function(){
                return `width: ${ this.totalPotsUsed/this.TOTAL_AMOUNT_OF_POTS * 100 }%`
            }
        },
        myBasketRecommendations:{
            get: function(){
                const recommendations = this.basketRecommendations.filter(recommendation =>{
                    const offerNotInBasket = this.basket.offers.reduce((recommendationIsNotInBasket,{ _id }) => recommendationIsNotInBasket && recommendation._id !== _id, true);

                    if(offerNotInBasket){
                        return recommendation;
                    }
                });

                if(!(this.basket.isDeliveredIn || this.basket.isContract))
                    return recommendations;

                if(this.basket.isContract)
                    return recommendations.map(r => makeGenericContractFromContractFrequency(r));

                return recommendations.map(r => {
                    r.price = r.dayDeliveryPpl;
                    return r;
                })
            }
        },
        totalCost:{
            get: function(){
                if(this.basket.offers.length < 1) return 0;
                return this.basket.offers.reduce((total, { price, quantity }) => total + (price * (quantity ? quantity : 0) / 100), 0);
            }
        },
        totalVolume:{
            get: function(){
                return this.basket.offers.reduce((acc, { quantity }) => {
                    return acc + quantity
                    }, 0);
            }
        },
        creditLineRequiredBool:{
          get: function(){
            return this.showCreditLineSelection && (this.basket.brand === -1 || this.basket.brand == null) && this.confirmCheckbox;
          }
        },
        //We'll have to figure out how we want to display use this, just wanted to hold onto requirements that should disallow buying
        requirementsNotSatisfied:{
            get: function(){
                if(this.basket.offers.length === 0) return true;

                if(this.errorMessageBool && this.errorMessage === CREDIT_LIMIT_ERROR)
                    this.closeErrorMessage();

                const availableQuantityInsufficient = this.basket.offers.reduce((acc, { quantity, maximumAvailable, minimumOrderQuantity }) => {
                    if(quantity == null)
                        return true;
                    return acc || quantity > maximumAvailable || quantity < minimumOrderQuantity;
                }, false);

                //Check that all references for individual items are filled in
                let offerReferenceEmpty = false;
                if (this.basket.isBunkering && !this.basket.isContract)
                    offerReferenceEmpty = this.basket.offers.reduce((acc, { reference }) => acc || reference === '' || reference == null, false);

                if(this.confirmCheckbox){
                    this.confirmCheckbox = !availableQuantityInsufficient 
                        && this.basket.isDeliveredIn ? this.totalPotsUsed === this.TOTAL_AMOUNT_OF_POTS : true;
                }

                return availableQuantityInsufficient || offerReferenceEmpty || this.creditLineRequiredBool || !this.confirmCheckbox;
            }
        },
        totalPotsUsed:{
            get: function(){
                if(this.basket.offers.length < 1) return 0;
                return this.basket.offers.reduce((acc, { quantity, fuel }) => {
                    if(quantity == null) return acc;
                    if(fuel._id === this.productConfig.KeroseneId)
                        return acc + (quantity / this.KERO_POT_SIZE)
                    return acc + (quantity / this.OTHER_POT_SIZE);
                    }, 0);
            }
        }
    },
    methods: {
        ...mapActions('offers',['getBasketRecommendations', 'clearBasket', 'getLiveOffers']),
        ...mapActions('notifications', ['getNotifications']),
        getHeading(){
            if(this.basketProp.isBunkering){
                return this.basketProp.isContract ? `Confirm Bunkering Contract` : `Confirm Bunkering Order`;
            } else if(this.basketProp.isDeliveredIn){
                return "Confirm Delivered In Order";
            } else {
                return this.basketProp.isContract ? `Confirm Ex-Rack Contract` : `Confirm Spot Ex-Rack Order`;
            }
        },
        getFullNetworkName(networkId){
          if(networkId === this.networkConfig.KeyFuelsId) return "Keyfuels";
          if(networkId === this.networkConfig.UkFuelsId) return "UK Fuels";
            return "Network";
        },
        getPotsDin(offer){
            const potSize = offer.fuel._id === this.productConfig.KeroseneId ? this.KERO_POT_SIZE : this.OTHER_POT_SIZE
            return `${offer.quantity / potSize} Pot${offer.quantity / potSize === 1 ? "" : "s"}`
        },
        getPriceDin(offer){
            const potSize = offer.fuel._id === this.productConfig.KeroseneId ? this.KERO_POT_SIZE : this.OTHER_POT_SIZE
            return `@ ${priceFormat(potSize * offer.price / 100)}`
        },
        maxMinPlaceholderValues(offer){
            if(offer.minimumOrderQuantity && offer.maximumAvailable){
                return `${volumeFormat(offer.minimumOrderQuantity)} - ${volumeFormat(offer.maximumAvailable)} L`
            }
            return 'Enter Volume...'
        },
        offerQuantityValidError(offer){
            if((offer.quantity < offer.minimumOrderQuantity || offer.quantity > offer.maximumAvailable) && offer.quantity != null && offer.quantity !== '')
                return `Enter between ${volumeFormat(offer.minimumOrderQuantity)} - ${volumeFormat(offer.maximumAvailable)}`
            return false
        },
        bunkeringAccountInputError(offer) {
            if (offer.reference !== "" && offer.reference !== null) {
                return false
            } 
            return true
        },
        updateBrandValue: function(brand){
          this.basket.brand = brand;
          this.disableCheckBox();
        },
        disableCheckBox() {
          this.confirmCheckbox = false;
        },
        dinOptions: function(offer){
            if(offer.fuel._id === this.productConfig.KeroseneId){
                return this.basket.keroPotsOptions.filter((pot, i) =>{
                    //For future reference: This says if the index is smaller than the amount of pots left, 
                    //OR if the pot size is smaller than what we already have for that offer
                    //AND The pot also always has to be smaller than the maximum available of the offer
                    const potsIHave = offer.quantity / this.KERO_POT_SIZE;
                    return (i <= this.TOTAL_AMOUNT_OF_POTS - (this.totalPotsUsed - potsIHave)  || pot <= offer.quantity) && pot <= offer.maximumAvailable;
                })
            } else {
                return this.basket.restPotsOptions.filter((pot, i) => {
                    const potsIHave = offer.quantity / this.OTHER_POT_SIZE;
                    return (i <= this.TOTAL_AMOUNT_OF_POTS - (this.totalPotsUsed - potsIHave)  || pot <= offer.quantity) && pot <= offer.maximumAvailable;
                })
            }
        },
        createBasketRecommendations(offer){
            this.getBasketRecommendations(createBasketRecommendationsQuery(offer, null, this.basketProp.isBunkering, this.basketProp.isContract, this.basketProp.isDeliveredIn, this.basketProp.deliveredInData));
        },
        refreshBasket: async function(){
            event.srcElement.disabled = true;
            this.closeErrorMessage();

            const basketResponse = await createServerSideBasket(this.marketWindowId, this.basketProp.offers)
            if(this.basket.isDeliveredIn)
                makeOfferBasketIntoDeliveredIn(basketResponse.basketId, this.basketProp.offers[0])
            this.basket.id = basketResponse.basketId;
            this.basket.basketExpiry = basketResponse.expiry;
            this.basket.basketCreated = new Date();

            const query = createBasketRecommendationsQuery(this.basketProp.offers[0], null, this.basketProp.isBunkering, this.basketProp.isContract, this.basketProp.isDeliveredIn, this.basketProp.deliveredInData);
            const response = await getRecommendedOffers(query);

            if(response.body && response.body.length < 1){
                this.triggerErrorMessageStopTimerCloseButton(OFFER_REMOVED_ERROR);
                event.srcElement.disabled = false;
                return;
            }
            const offersInBasket = this.basket.offers.map(offer => {
                const newOffer = response.body.find(o => o._id === offer._id);
                if(!newOffer){
                    this.triggerErrorMessageStopTimerCloseButton(OFFER_REMOVED_ERROR);
                }
                if(this.basket.isDeliveredIn)
                    newOffer.price = newOffer.dayDeliveryPpl;
                newOffer.quantity = offer.quantity;
                if (newOffer.contract && newOffer.contract.frequency_quantity && newOffer.contract.frequency_quantity.length > 0) {
                    newOffer.maximumAvailable = this.offerVolumeDisplay(newOffer)
                }
                return newOffer;
            }, [])
            this.basket.offers = Object.assign([], offersInBasket);
            this.mixin_restartTimer();
            event.srcElement.disabled = false;
        },
        offerVolumeDisplay(offer) {
            const { currentMonthMaximumAvailable } = this.$options.filters;
            return currentMonthMaximumAvailable(offer.contract.frequency_quantity);
        },
        addOfferToBasket(item){
            this.confirmCheckbox = false;
            if(!item.quantity) 
                item = Object.assign({}, item, { quantity: null });
            item.price = Number(item.price.toFixed(2));
            this.basket.offers.push(item);
        },
        removeOfferFromBasket(offer){
          this.confirmCheckbox = false;
          this.basket.offers = this.basket.offers.filter(o=> o._id !== offer._id);
        },
        buyOffer: async function(event){
          event.srcElement.disabled = true;

          const creditLimitInsufficient = this.basket.offers[0].credit.limit < this.totalCost;

          if(creditLimitInsufficient){
            this.confirmCheckbox = false;
            return this.triggerErrorMessage(CREDIT_LIMIT_ERROR);
          }

          try {
              const sellerAccountId = this.basket.offers[0].account_id;
              await Promise.all([updateSelectedBrandInBasket(this.basket, sellerAccountId), addAllItemsToApiBasket(this.basket.offers, this.basket.id)]);
                let clientReference;
                if(this.basket.isContract){
                    clientReference = this.basket.offers.reduce((acc, { contract }) => `${ acc } ${ contract.reference }${ this.basket.offers.length > 1 ? ';' : '' }`, '')
                } else {
                    clientReference = this.basket.reference
                }

                const payload = {
                    basketId: this.basket.id,
                    clientReference: clientReference
                }

                if(this.basket.isDeliveredIn)
                    payload.deliveryNotes = this.basket.deliveryNotes
                else {
                    payload.orderNotes = this.basket.orderNotes;
                }
                const response = await placeOrderV2(payload);
                this.getNotifications();
                this.$emit('triggerReceiptModal', response.data.order);
                this.closeModal();
                this.getLiveOffers();
            } catch(err) {
              const errMessage = err.response && err.response.data && err.response.data.message;
                switch(errMessage){
                case 'OFFER_REMOVED_ERROR':
                    this.triggerErrorMessageStopTimerCloseButton(OFFER_REMOVED_ERROR);
                    break;
                case 'OFFER_UPDATED_ERROR':
                    this.triggerErrorMessageStopTimer(OFFER_UPDATED_ERROR);
                    break;
                case 'Market Window has expired':
                    this.triggerErrorMessageStopTimerCloseButton(MARKET_WINDOW_BASKET_ERROR);
                    break;
                default:
                    this.triggerErrorMessage();
                }
            }
        },
        triggerErrorMessageStopTimerCloseButton(errorMessage){
            this.closeBasketBool = true
            this.triggerErrorMessage(errorMessage)
            this.mixin_stopTimer()
        },
        triggerErrorMessageStopTimer(errorMessage){
            this.triggerErrorMessage(errorMessage)
            this.mixin_stopTimer()
        },
        triggerErrorMessage(errorMessage){
            if(errorMessage)
                this.errorMessage = errorMessage
            else this.errorMessage = 'Something went wrong, please refresh :('
            this.errorMessageBool = true
        },
        closeErrorMessage(){
            this.errorMessageBool = false
        },
        closeModal(){
            this.clearBasket();
            $('#OfferBasket').modal('hide')
            this.$emit('hideBasket')
        },
        isNumberKeyEvent: isNumberKeyEvent
      }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/components/_basket-countdown.scss";
@import "@/assets/scss/components/_modals.scss";

.recommendations {
    width: 49%;
    min-width: 300px;
    @include media-breakpoint-down(sm) {
        min-width: 75vw;
    }
    &:nth-child(odd) {
        margin-right: 2%;
    }
}
.recommendations-parent {
    padding: 1.845rem;
}
.litres {
    padding-left: 3px;
}
.select-wrapper {
    @include media-breakpoint-down(xs) {
        min-width: 100px;
    }
}
.hidden {
    display: none;
}

</style>
